import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12\"><div class=\"pb-10 pb-lg-15\"><h2 class=\"fw-bolder d-flex align-items-center text-dark\"> Review and Complete <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Choose Plan\"></i></h2><div class=\"text-gray-400 fw-bold fs-6\"> If you need more info, please check out <a href=\"#\" class=\"link-primary fw-bolder\">Help Page</a>. </div></div></div><div class=\"col-12\"><div class=\"fs-6 text-gray-600 mb-10 text-center\"> Your applicant(s) will receive an email with further steps after successful payment </div></div>", 2)
const _hoisted_5 = { class: "col-12 col-lg-6 mx-auto" }
const _hoisted_6 = { class: "pb-10 pb-lg-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummaryCard = _resolveComponent("SummaryCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_SummaryCard, {
            title: "Selected Plan",
            subtitle: _ctx.plan?.name,
            "right-text": 
              _ctx.$filters.formatCurrency(_ctx.getPlanPriceByCurrency(_ctx.plan, 'usd'))
            ,
            icon: "/media/icons/duotune/finance/fin006.svg",
            variant: "bg-light-warning",
            color: "warning"
          }, null, 8, ["subtitle", "right-text"]),
          _createVNode(_component_SummaryCard, {
            title: "Number of Applicants",
            subtitle: "We will perform checks on these applicants",
            "right-text": _ctx.formData.applicants.length,
            icon: "/media/icons/duotune/general/gen024.svg",
            variant: "bg-primary-info",
            color: "primary"
          }, null, 8, ["right-text"]),
          _createVNode(_component_SummaryCard, {
            title: "Included AML Verifications",
            subtitle: `You added AML checks for ${_ctx.amlApplicants} applicants`,
            "right-text": _ctx.$filters.formatCurrency(_ctx.amlTotal),
            icon: "/media/icons/duotune/general/gen024.svg",
            variant: "bg-light-info",
            color: "info"
          }, null, 8, ["subtitle", "right-text"]),
          (!_ctx.useActiveSubscription)
            ? (_openBlock(), _createBlock(_component_SummaryCard, {
                key: 0,
                title: "Fee Breakdown",
                subtitle: _ctx.feeBreakdown,
                "right-text": _ctx.$filters.formatCurrency(_ctx.totalFees, 'usd'),
                icon: "/media/icons/duotune/finance/fin010.svg",
                variant: "bg-light-danger",
                color: "danger"
              }, null, 8, ["subtitle", "right-text"]))
            : _createCommentVNode("", true),
          (!_ctx.useActiveSubscription)
            ? (_openBlock(), _createBlock(_component_SummaryCard, {
                key: 1,
                title: "Subtotal",
                subtitle: "Charge amount - Total Price + Total Fees",
                "right-text": 
              _ctx.$filters.formatCurrency(_ctx.totalPrice + _ctx.totalFees + _ctx.amlTotal)
            ,
                icon: "/media/icons/duotune/finance/fin010.svg",
                variant: "bg-light-success",
                color: "success",
                "right-variant": "badge-primary"
              }, null, 8, ["right-text"]))
            : _createCommentVNode("", true),
          (_ctx.useActiveSubscription)
            ? (_openBlock(), _createBlock(_component_SummaryCard, {
                key: 2,
                title: "Subscription Active",
                subtitle: "A subscription is activated for your verification",
                "right-text": "Yes",
                icon: "/media/icons/duotune/general/gen024.svg",
                variant: "bg-light-info",
                color: "info"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}